async function startGReady() {
  try {
    const response = await fetch("https://api.inhero.com/api/init");

    if (!response.ok) {
      throw new Error(
        `Network response was not ok: ${response.statusText}`
      );
    }

    const data = await response.json();

    // Always save the init value
    sessionStorage.setItem("initValue", data.init);

    // Save country if provided
    if (data.country) {
      sessionStorage.setItem("country", data.country);
    }

    // Save state if provided
    if (data.state) {
      sessionStorage.setItem("state", data.state);
    }
  } catch (error) {
    console.error(
      "There has been a problem with your fetch operation:",
      error
    );
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (sessionStorage.getItem("initValue") === null) {
    startGReady();
  }
});